import { isAdmin, isSuperAdmin, isContentManager, isRetail, isBasic } from '../utils/acls';
import { isAgentRoute, isAdminRoute, isContentManagerRoute, isSuperAdminRoute, isRetailRoute } from '../utils/routes';

export const blocks = {
  retail: {
    test: user => isRetail(user) && !isBasic(user),
    label: 'Menu',
    filter: isRetailRoute,
  },
  agent: {
    test: isBasic,
    label: 'Menu',
    filter: isAgentRoute,
  },
  admin: {
    test: isAdmin,
    label: 'Lead Agents',
    filter: isAdminRoute,
  },
  contentManager: {
    test: isContentManager,
    label: 'Content Managers',
    filter: isContentManagerRoute,
  },
  superAdmin: {
    test: isSuperAdmin,
    label: 'Super Admins',
    filter: isSuperAdminRoute,
  },
};
